const baseURL2 = "https://newfriendsjewellers.com:5000";


export default baseURL2;